import { Component, OnInit } from "@angular/core";
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RequirementService } from "../../core/services/requirement.service";
import { SessionService } from "../../core/services/session.service";
import { EtapasBeneficioComponent } from "../../shared/components/etapas-beneficio/etapas-beneficio.component";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatInputModule,
    EtapasBeneficioComponent
  ],
  selector: 'app-requerimento-download',
  templateUrl: './requerimento-download.component.html',
  styleUrl: './requerimento-download.component.scss'
})
export class RequerimentoDownloadComponent implements OnInit {

  beneficiario: any = '';
  downloading = false;
  dataRequerimento: string = '';
  observacao: string = '';

  constructor(
    private requirementService: RequirementService,
    private sessionService: SessionService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.beneficiario = this.sessionService.beneficiario;
  }

  baixarPDF(tipo: string): void {
    this.sessionService.orgao = this.beneficiario.orgao.id;
    this.sessionService.matricula = this.beneficiario.matricula;

    const hoje = new Date().toISOString().split('T')[0];

    const payload = {
      "matricula": this.beneficiario.matricula,
      "orgaoId": this.beneficiario.orgao.id,
      "tipoAposentadoria": tipo,
      "observacao": this.observacao || tipo,
      "dataRequerimento": this.dataRequerimento || hoje
    };

    this.downloading = true;

    this.requirementService.getDocumentPdf(payload).subscribe({
      next: (blob) => {
        this.downloading = false;
        const file = new Blob([blob], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = `requerimento.pdf`;
        a.click();
        URL.revokeObjectURL(url);
        this.snackBar.open('Download realizado com sucesso!', 'Fechar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      },
      error: (err) => {
        this.downloading = false;
        console.error('Erro ao baixar PDF:', err);
        this.snackBar.open('Erro ao baixar PDF. Tente novamente.', 'Fechar', {
          duration: 4000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        });
      }
    });
  }
}
